var _defs, _path, _path2, _path3, _path4, _circle, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew310({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.51,5V1.77H.86V5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.53,5V4.54H1.9V5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.4,3.43a2,2,0,0,1,.36-1.27,1.12,1.12,0,0,1,.91-.44,1.09,1.09,0,0,1,.63.19,1.28,1.28,0,0,1,.46.58,2.22,2.22,0,0,1,.17.9A1.92,1.92,0,0,1,4.6,4.55a1.11,1.11,0,0,1-.94.5,1.1,1.1,0,0,1-.94-.51A1.93,1.93,0,0,1,2.4,3.43Zm.36,0A1.49,1.49,0,0,0,3,4.36a.79.79,0,0,0,.64.32.81.81,0,0,0,.65-.33,1.56,1.56,0,0,0,.26-1,2,2,0,0,0-.14-.75.94.94,0,0,0-.31-.4.76.76,0,0,0-.45-.15A.79.79,0,0,0,3,2.41,1.66,1.66,0,0,0,2.76,3.43Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.43,5V4.54h.36V5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 10.6,
    cy: 10.6,
    r: 3.35
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 6.2,
    y: 6.2,
    width: 8.8,
    height: 8.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew310);
export default __webpack_public_path__ + "static/media/Symbolpack_New_310.ae8f57f31561f95cc05e048415242e2d.svg";
export { ForwardRef as ReactComponent };